/**
 * Utility function intended to tag interpolated routes.
 *
 * All expressions will be encoded via `encodeURIComponent`.
 * */
export const routeTag = (
  strings: TemplateStringsArray,
  ...values: (string | number | boolean)[]
): string => {
  let result = strings[0]

  for (let i = 1; i < strings.length; i += 1) {
    // Per https://jsperf.app/concatenations, plus-concatenation is fastest.
    result += encodeURIComponent(values[i - 1])
    result += strings[i]
  }

  return result
}
